import { ExtendedBlob } from '@/shared/models/extended-blob'

export class EditableImageChangedEvent {
  constructor(public image: ExtendedBlob, public imageUrl: string) {}
}
